import { createRouter, createWebHistory } from 'vue-router';

import App from './App.vue';
import { BROWSE_ARTICLES } from './store/constants';

// Lazy-load views to reduce initial bundle size
const ArticleListView = () => import('./symphony/views/ArticleListView.vue');
const ArticleDetailView = () => import('./symphony/views/ArticleDetailView.vue');

const routes = [{ path: '/', component: App, name: 'home' }];

// Add article routes if feature is enabled
if (BROWSE_ARTICLES) {
  routes.push(
    { path: '/articles/', component: ArticleListView, name: 'articleList' },
    { path: '/articles/:uri', component: ArticleDetailView, name: 'articleDetail' },
  );
}

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_PUBLIC_PATH || ''),
  routes,
});

export default router;
